import React from 'react';
import { useNavigate } from 'react-router-dom';
import MobileShell from './components/MobileShell';

/**
 * Placeholder de mensajes mobile. Por ahora redirige al chat existente para
 * no duplicar lógica; si se quiere una experiencia 100% nativa-mobile, se
 * puede iterar sobre este shell.
 */
export default function MobileMessages() {
  const navigate = useNavigate();
  return (
    <MobileShell title="Mensajes">
      <section className="px-5 pt-12 flex flex-col items-center text-center">
        <div className="w-20 h-20 rounded-xl bg-primary/10 flex items-center justify-center">
          <span className="material-symbols-outlined text-3xl text-primary">forum</span>
        </div>
        <h2 className="mt-4 text-xl font-black text-on-surface">Tus chats</h2>
        <p className="mt-2 text-sm text-on-surface-variant max-w-[280px]">
          Coordiná tus compras y trades. Para esta vista mobile usamos el mismo chat que en desktop.
        </p>
        <button
          type="button"
          onClick={() => navigate('/messages')}
          className="mt-6 min-h-[48px] px-6 rounded-xl bg-primary text-on-primary font-bold text-sm"
        >
          Abrir chats
        </button>
      </section>
    </MobileShell>
  );
}
